export default defineNuxtRouteMiddleware((to) => {
	const { public: { maintenance: isMaintenanceModeEnabled } } = useRuntimeConfig();

	if (isMaintenanceModeEnabled) {
		if (to.name === 'MerchantContentPage') {
			return;
		}

		throw createError({
			status: 503,
			statusText: 'app-is-under-maintenance',
			unhandled: false,
		});
	}
});
